
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import { Button } from '@mui/material';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import { home, carrers } from '../../helper/routes';
import MenuItem from '../MenuItem';
import React from "react"
import { ErrorColor, NeutralColor } from '../../helper/constants/colors';
import { useMenu } from '../../helper/functions/hooks/menu';
import { usePublisher } from '../../helper/functions/hooks/events';
import { MENU_CLICKED } from '../../events';

const Menu = (): JSX.Element => {
    const { opened, openMenu, closeMenu, redirect } = useMenu()
    const publish = usePublisher()
    return (
        <div className='Menu' onClick={closeMenu}>
            <Button onClick={(): void => {
                publish<boolean>(MENU_CLICKED, true) 
                openMenu()
            }}>
                <MenuIcon fontSize='large' htmlColor={NeutralColor.light} />
            </Button>
            <Drawer
                anchor='left'
                open={opened}>
                <List>
                    {
                        home.map((route, index) =>
                            <MenuItem
                                key={index}
                                icon={route.icon}
                                title={route.title}
                                onClick={(): void => redirect(route.path)} />
                        )
                    }
                    <Divider />
                    {
                        carrers.map((route, index) =>
                            <MenuItem
                                key={index}
                                icon={route.icon}
                                title={route.title}
                                onClick={(): void => redirect(route.path)} />
                        )
                    }
                    <Divider />
                    <MenuItem
                        icon={<CloseIcon htmlColor={ErrorColor.main} />}
                        title="Close"
                        onClick={closeMenu} />

                </List>

            </Drawer>
        </div>
    )
}
export default Menu;
